import { CloseCircleTwoTone, ExclamationCircleTwoTone, InfoCircleTwoTone } from '@ant-design/icons';
import { Card, Flex, Typography } from 'antd';
import DOMPurify from 'dompurify';

import { BannerType } from 'enums/banner-type.enum';
import { getFormattedDate } from 'helpers/get-formatted-date';

import styles from './News.module.scss';
import { Banner } from '../../types/banners.types';
import { DAILY_FORMAT } from '../../constants-module';

interface NewsItemProps {
  banner: Banner;
}

export const NewsItem = ({ banner }: NewsItemProps) => {
  const { title, description, type, bannerId, createdAt, detail } = banner;

  const getType = () => {
    let iconType;

    if (type === BannerType.Error) {
      iconType = <CloseCircleTwoTone twoToneColor="#ff4d4f" />;
    } else if (type === BannerType.Warning) {
      iconType = <ExclamationCircleTwoTone twoToneColor="#ffa500" />;
    } else if (type === BannerType.Info) {
      iconType = <InfoCircleTwoTone />;
    }

    return iconType;
  };

  return (
    <Card title={title} extra={<>{getType()}</>} id={bannerId} key={bannerId}>
      <Flex gap="small" vertical className={styles.newsBanner}>
        <Flex align="center" gap="small" className={styles.newsContent}>
          <Typography.Text strong className={styles.newsTextContent}>
            {getFormattedDate(createdAt, DAILY_FORMAT)}
          </Typography.Text>
        </Flex>
        <Typography.Text className={styles.newsTextContent}>{description}</Typography.Text>
        {detail && (
          /* We disable this rule as inserted html string is sanitized from potentially dangerous tags */
          /* eslint-disable-next-line react/no-danger */
          <div className={styles.newsTextContent} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(detail) }} />
        )}
      </Flex>
    </Card>
  );
};
